/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { Chip } from "@mui/material";
import { SOURCE_OF_TRUTH_LABELS } from "../render_job_list";

// Matches the fetch data modal's source cards, so a provider reads the same across the app.
export const SOURCE_OF_TRUTH_COLORS = {
  toast: "#EA580C",
  seven_shifts: "#1976d2",
  manual: "#64748b",
};

const DEFAULT_COLOR = "#64748b";

// Renders a record's provider as a coloured chip with its full name (not the job title
// column's [7S]/[T] acronym), or a dash when it is unknown.
export const SourceOfTruthBadge = React.memo(({ source, dataTestId }) => {
  const label = SOURCE_OF_TRUTH_LABELS[source];

  if (!label) {
    return <span data-testid={dataTestId}>-</span>;
  }

  const badgeColor = SOURCE_OF_TRUTH_COLORS[source] || DEFAULT_COLOR;

  return (
    <Chip
      size="small"
      data-testid={dataTestId}
      aria-label={`source: ${label}`}
      label={label}
      sx={{
        backgroundColor: badgeColor,
        color: "#ffffff",
        fontWeight: 600,
        "&:hover": { backgroundColor: badgeColor, color: "#ffffff" },
      }}
    />
  );
});

SourceOfTruthBadge.displayName = "SourceOfTruthBadge";
